import axios from "axios";
import { getAuth } from "../providers/AppAuthProvider";

import { API_BASE_URL as baseUrl } from 'src/utils/api-url';

export interface SessionView {
  id: string;
  current: boolean;
  status: 'active' | 'revoked' | 'expired';
  ip: string | null;
  userAgent: string | null;
  browser: { name: string; version: string | null } | null;
  os: { name: string; version: string | null } | null;
  device: { type: string | null; vendor: string | null; model: string | null };
  createdAt: string;
  lastUsedAt: string;
  expiresAt: string;
  revokedAt: string | null;
}

export interface SessionList {
  data: SessionView[];
  total: number;
  page: number;
  size: number;
}

export interface RevokeResult {
  userId: string;
  revokedSessionIds: string[];
}

async function headers() {
  const { accessToken } = (await getAuth()) || {};
  return {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };
}

// XBIT-4828 D9. A 401 is left to the XBIT-4826 interceptor; any other failure reaches the caller as an axios error.
export async function listMySessions(page: number, size: number) {
  return axios.get<SessionList>(`${baseUrl}/auth/sessions`, {
    headers: await headers(),
    params: { page, size },
  });
}

export async function revokeMySession(sid: string) {
  return axios.delete<RevokeResult>(`${baseUrl}/auth/sessions/${sid}`, { headers: await headers() });
}

export async function revokeMyOtherSessions() {
  return axios.post<RevokeResult>(`${baseUrl}/auth/sessions/revoke-others`, undefined, {
    headers: await headers(),
  });
}

export async function listUserSessions(userId: string, page: number, size: number) {
  return axios.get<SessionList>(`${baseUrl}/users/${userId}/sessions`, {
    headers: await headers(),
    params: { page, size },
  });
}

export async function revokeUserSession(userId: string, sid: string) {
  return axios.delete<RevokeResult>(`${baseUrl}/users/${userId}/sessions/${sid}`, {
    headers: await headers(),
  });
}

export async function revokeAllUserSessions(userId: string) {
  return axios.delete<RevokeResult>(`${baseUrl}/users/${userId}/sessions`, {
    headers: await headers(),
  });
}
